module.exports = __webpack_public_path__ + "static/og-96a43d199a2c44b0ec55c5514c4a1db4.jpg";